export default {
  READING_SETTINGS: 'ReadingSettingsTab',
  NOTES: 'NotesTab',
  BOOKMARKS: 'BookmarksTab',
  TABLE_OF_CONTENTS: 'TableOfContentsTab',
  SOCIAL_SHARING: 'SocialSharingTab'
};
